import { BlockType } from './blockTypes';
import { ContentBlockObject } from './contentBlock';
import { SanityAsset } from '@sanity/image-url/lib/types/types';
import { ProffModuleConfigBase } from '../proff/proffTypes';

export enum LegacyBannerType {
  Image = 'legacyImageBanner',
  MGA = 'legacyMGABanner',
  Intranet = 'legacyIntranetBanner',
  Proff = 'legacyProffBanner',
}

export interface LegacyBannerImage {
  _type: LegacyBannerType.Image;
  image: SanityAsset;
}

export interface LegacyBannerMGA {
  _type: LegacyBannerType.MGA;
  order_module: {
    slug: string;
  };
}

export interface LegacyBannerIntranet {
  _type: LegacyBannerType.Intranet;
}

export interface LegacyBannerProff {
  _type: LegacyBannerType.Proff;
  proff_module: ProffModuleConfigBase;
}

export interface BlockLegacyBanner extends ContentBlockObject<BlockType.LegacyBanner> {
  variant: (LegacyBannerImage | LegacyBannerMGA | LegacyBannerProff | LegacyBannerIntranet)[];
}
